import React from "react";
import City from "./components/City";
import Country from "./components/Country";
import Division from "./components/Division";
import Neighbourhood from "./components/Neighbourhood";

const Location = () => {
  return (
    <div className="space-y-10">
      <Country />
      <Division />
      <City />
      <Neighbourhood />
    </div>
  );
};

export default Location;
